/* Collection header card.
   The collection header is built from several separate Dawn sections rendered
   as siblings: breadcrumbs, the title (rich-text <h1>), collection links, and
   the dietary icons. To draw a single card around the whole group we wrap that
   contiguous run of sections in one .ap-collection-header-card div at runtime.
   Styling lives in ap-collection-header-card.css. */
(function () {
  'use strict';

  function wrap() {
    if (document.querySelector('.ap-collection-header-card')) return; // already done

    var main = document.querySelector('#MainContent') || document.body;

    // Anchors that identify the header pieces (any may be absent on a given
    // collection). The title is the page <h1> rendered by the rich-text block.
    var anchors = [
      main.querySelector('.collection-breadcrumbs'),
      main.querySelector('h1'),
      main.querySelector('.random-collection-links'),
      main.querySelector('.ap-freefrom-product-mobile')
    ];

    var sections = [];
    anchors.forEach(function (a) {
      if (!a) return;
      var s = a.closest('.shopify-section');
      if (s && sections.indexOf(s) < 0) sections.push(s);
    });
    if (!sections.length) return;

    // Only group sections that are true siblings under the same parent.
    var parent = sections[0].parentNode;
    sections = sections.filter(function (s) { return s.parentNode === parent; });

    // Order by DOM position, then take the first and last as the range bounds.
    sections.sort(function (a, b) {
      return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });
    var first = sections[0];
    var last = sections[sections.length - 1];

    // Collect the contiguous run first..last (captures the title in between).
    var range = [];
    var n = first;
    while (n) {
      range.push(n);
      if (n === last) break;
      n = n.nextElementSibling;
    }
    if (range[range.length - 1] !== last) return; // not contiguous — bail safely

    var card = document.createElement('div');
    card.className = 'ap-collection-header-card';
    parent.insertBefore(card, first);
    range.forEach(function (x) { card.appendChild(x); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrap);
  } else {
    wrap();
  }
})();
